import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { sessionID, sessionIdInterceptor } from './SessionID';
import axiosRetry from 'axios-retry';
import loggerInstance from '../libs/logger/Logger';
import { AccessTokenContext, Permission } from './types';

interface IMe {
  accessToken: string;
}

export class LoginService {
  loginService: AxiosInstance;

  constructor(loginServiceBaseUrl: string) {
    this.loginService = axios.create({
      baseURL: loginServiceBaseUrl,
    });
    axiosRetry(this.loginService, {
      retries: Infinity,
      retryDelay: () => 1000,
      onRetry: (retryCount) => loggerInstance.error(`Couldn't connect to LoginService. Retries count: ${retryCount}`),
    });
    this.loginService.interceptors.request.use((config) => sessionIdInterceptor(config));
  }

  me(context: AccessTokenContext, permissions?: Permission[]): Promise<string> {
    const data = { customer: context?.customer, site: context?.site, permissions };

    return this.loginService
      .post('api/me', data, {
        baseURL: this.loginService.defaults.baseURL,
        withCredentials: true,
        headers: {
          'TraceAir-Session-Id': sessionID,
        },
      })
      .catch((err: AxiosError) => {
        if (err.response?.status === 401 || err.response?.status === 403) {
          LoginService.redirectToSigninPage();
        }

        throw err;
      })
      .then((response: AxiosResponse<IMe>) => response.data.accessToken);
  }

  logout(): Promise<void> {
    return this.loginService.post('api/logout', {}, { withCredentials: true });
  }

  static redirectToSigninPage() {
    location.href = `${SignInPageUrl}?referer=${encodeURIComponent(
      location.href,
    )}&loginServiceBaseUrl=${encodeURIComponent(LoginServiceBaseUrl)}`;
  }
}
